import { Pipe, PipeTransform } from '@angular/core';

import { STATUS_TYPE } from '@constants/status-type.constant';
import { DeclarationStatus } from '@enums/declaration-status.enum';
import { StatusType } from '@modules/core/types/status-type.type';
import { Status } from '@modules/core/types/status.type';

@Pipe({
  name: 'statusLabel',
  standalone: true
})
export class StatusLabelPipe implements PipeTransform {
  transform(value: Status, statusType: StatusType = 'declaration', draftStatusLabel?: string): string {
    if (!value) {
      return '';
    }

    if (
      statusType === 'declaration' &&
      draftStatusLabel &&
      (value === DeclarationStatus.draft || value === DeclarationStatus.preDraft)
    ) {
      return draftStatusLabel;
    }

    return STATUS_TYPE[statusType](value)?.label ?? '';
  }
}
